import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingBar } from '../components/ui/loading-bar';
import Layout from '../components/Layout';

export default function ProtectedLayout() {
  const { isSessionValid, loading } = useAuth();

  if (loading) {
    return (
      <Layout title="">
        <LoadingBar visible />
      </Layout>
    );
  }

  if (!isSessionValid) {
    return <Navigate to="/auth" replace />;
  }

  return <Outlet />;
}
